export const SelectObject = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.25 3H9.75V1.5H14.25V3ZM6 1.5V3H4.5C3.67157 3 3 3.67157 3 4.5V6H1.5V4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H6ZM18 3H19.5C20.3284 3 21 3.67157 21 4.5V6H22.5V4.5C22.5 2.84315 21.1569 1.5 19.5 1.5H18V3ZM22.5 9.75H21V14.25H22.5V9.75ZM9.75 21H14.25V22.5H9.75V21ZM6 21H4.5C3.67157 21 3 20.3284 3 19.5V18H1.5V19.5C1.5 21.1569 2.84315 22.5 4.5 22.5H6V21ZM3 14.25V9.75H1.5V14.25H3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M18.6057 23.4729L19.6137 20.9919C19.7053 20.801 19.8886 20.6102 20.1635 20.5148L22.6378 19.8468C23.3709 19.6559 23.4625 18.6063 22.821 18.32L16.1314 15.0756C15.49 14.7893 14.8485 15.3618 15.0318 16.0298L17.1395 23.3775C17.3227 24.1409 18.3308 24.2363 18.6057 23.4729Z"
      fill="currentColor"
    />
  </svg>
);
